import classNames from 'classnames/bind';
import React from 'react';

import styles from './OperationItem.module.scss';

const cx = classNames.bind(styles);

const OperationItem = ({ dataset }) => {
  return (
    <div className={cx('container')}>
      <div className={cx('context')}>
        <div className={cx('date')}>{dataset.date}</div>
        <div className={cx('timeWrapper')}>
          <div className={cx('time')}>
            {dataset.startedAt} - {dataset.endedAt}
          </div>
          <div className={cx('duration')}>({dataset.duration})</div>
        </div>
      </div>
      {dataset.inFlight && <div className={cx('current')}>In Flight</div>}
    </div>
  );
};

export default OperationItem;
